module.exports = __webpack_public_path__ + "static/media/dyk-meds@2x.abb2713c.png";